var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isCluji())?_c('calendar-links-card'):_vm._e(),_c('cluji-card',{attrs:{"no-header":"","foldable":false}},[_c('calendar-options-picker',{model:{value:(_vm.toLoad),callback:function ($$v) {_vm.toLoad=$$v},expression:"toLoad"}}),_c('hr'),_c('cluji-calendar',{attrs:{"events":_vm.allEvents}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }